module.exports = __webpack_public_path__ + "media/images/icons/help-bd2f3bcb58bf102b832fcb3de40d8d85.svg";